export default __webpack_public_path__ + "static/MarkerMapAndCharTitle-66fd820e46b9e0902ac281e71cbe2b51.jpg";